import { Injectable } from '@angular/core';
import {BusinessPhoto, BusinessPhotoList} from './business_photo';
import {BaseService} from '../base/base.service';
import {BusinessPhotoSerializer} from 'src/app/business_photos/business_photo.serializer';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BusinessPhotoService extends BaseService<BusinessPhoto, BusinessPhotoList> {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'business_photos' ;
    this.serializer = new BusinessPhotoSerializer();
  }
}
